module.exports = __webpack_public_path__ + "static/media/ic-portfolio-liquidity.05fd6d81.svg";